export const linkResolver = doc => {
  if (doc.type === 'client_interview') {
    return `/avis/${doc.uid}`;
  }
  return '/';
};
